module.exports = __webpack_public_path__ + "images/a126dd6c9408b6fd1b55a3bae032665c.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/man/1.png
// module id = 361
// module chunks = 0